module.exports = __webpack_public_path__ + "static/img/cu-logo.4b8f14a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cu-logo.png
// module id = 9HHA
// module chunks = 0